export const DEFAULT_ACCEPTED_FILE_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
];

export const DEFAULT_MAX_FILE_SIZE = 25 * 1024 * 1024;

export const createLocalId = () => {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const formatFileSize = (value) => {
  const bytes = Number(value);
  if (!Number.isFinite(bytes) || bytes <= 0) {
    return "0 B";
  }

  const units = ["B", "KB", "MB", "GB", "TB"];
  const unitIndex = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const size = bytes / 1024 ** unitIndex;
  const rounded = unitIndex === 0 ? Math.round(size) : Math.round(size * 10) / 10;

  return `${rounded.toLocaleString(undefined, { maximumFractionDigits: 1 })} ${units[unitIndex]}`;
};

export const formatMaximumSize = (bytes) => {
  const formatted = formatFileSize(bytes);
  return formatted.replace(/\.0(?=\s)/, "");
};

export const isAcceptedMimeType = (mimeType, acceptedTypes) => {
  if (!mimeType || !Array.isArray(acceptedTypes) || acceptedTypes.length === 0) {
    return false;
  }

  return acceptedTypes.some((acceptedType) => {
    const normalized = String(acceptedType).trim().toLowerCase();
    if (!normalized.includes("/")) {
      return false;
    }
    if (normalized.endsWith("/*")) {
      return mimeType.toLowerCase().startsWith(normalized.slice(0, -1));
    }
    return mimeType.toLowerCase() === normalized;
  });
};

export const isDuplicateFile = (file, items) =>
  items.some((item) =>
    item.file &&
    item.file.name === file.name &&
    item.file.size === file.size &&
    item.file.lastModified === file.lastModified,
  );

export const validateFile = (
  file,
  { accept = DEFAULT_ACCEPTED_FILE_TYPES, maxSizeBytes = DEFAULT_MAX_FILE_SIZE, items = [] },
) => {
  if (!file || file.size === 0) {
    return "The selected file is empty.";
  }
  if (!isAcceptedMimeType(file.type, accept)) {
    return "File type is not supported.";
  }
  if (file.size > maxSizeBytes) {
    return `File exceeds the maximum allowed size of ${formatMaximumSize(maxSizeBytes)}.`;
  }
  if (isDuplicateFile(file, items)) {
    return "This file has already been selected.";
  }

  return null;
};
